import {
  postAddProductToWatchList,
  postAddProductToCart,
  getCategoriesAndSubCategories,
  getGetVariants,
  getShareProductLink,
} from '@_api/productdetail';
import { getCurrentRegion } from '@helpers/functions';

const productDetailPage = {
  miniCartNode: document?.querySelector<HTMLElement>('.saig-o-mini-cart'),
  cartCounter: document?.querySelector<HTMLDivElement>('.saig-a-button.button-cart > .saig-a-button__counter'),
  productDetailParentDiv: document?.querySelector<HTMLDivElement>('.saig-o-product-detail-main__main'),
  addToWishListRecordExistDiv: document?.querySelectorAll<HTMLDivElement>('.add-to-watchlist-response.wRecordExist'),
  addToWishListSuccessDiv: document?.querySelectorAll<HTMLDivElement>('.add-to-watchlist-response.wSuccess'),
  addToWishListErrorDiv: document?.querySelectorAll<HTMLDivElement>('.add-to-watchlist-response.wError'),
  addToWishListMaxErrorDiv: document?.querySelectorAll<HTMLDivElement>('.add-to-watchlist-response.wMaxError'),
  addToWishListGuestDiv: document?.querySelectorAll<HTMLDivElement>('.add-to-watchlist-response.wGuest'),
  termsCheckboxDiv: document?.querySelector<HTMLDivElement>('.saig-o-product-detail-main__cart-info-terms-checkbox'),
  popUpIdAvailableFormatModal: '',
  popUpIdProductFormatModal: '',
  popUpIdAddToWatchListHelpModal: '',
  popUpIdAddToWatchListGuestModal: '',
  popUpIdDRMLicenseModal: '',
  popUpIdAboutPdfDrmFormatModal: '',
  popUpIdAddToCartAPIErrorModal: '',
  popUpIdItemExistsInCartModal: '',
  popUpIdItemExistsInDifferentCurrencyInCartModal: '',
  selectedProductFormat: document?.querySelector<HTMLInputElement>("input[name='product-formats']"),
  currencyNode: document?.querySelector<HTMLInputElement>('input[name=currency]'),
  PriceSection: document?.querySelector<HTMLDivElement>('.saig-o-product-detail-main__cart-info-wrapper'),
  PriceSectionOverlay: document?.querySelector<HTMLDivElement>('.saig-o-product-detail-main__cart-info-wrapper-overlay'),
  PriceSectionMobile: document?.querySelector<HTMLDivElement>('.saig-o-product-header__mobile-bottom-fixed'),
  itemExistsInCartDifferentCurrency: false,
  sku: '',
  productSku: '',
  publisherId: '',
  loggedIn: '',
  addToWatchListUrl: '',
  addItemsToCartUrl: '',
  categoriesApiUrl: '',
  getShareProductLinkUrl: '',
  getVariantsUrl: '',
  cartPageUrl: '',
  checkoutUrl: '',
  IsDigitalPdt: '',
  isPdf: '',
  hasDRMSecureIcon: '',
  itemDisplayPrice: '',
  showRequestQuote: '',
  requestQuoteUrl: '',
  itemGstExempt: '',
  isLoginRequired: '',
  categoriesFlag: false,
  breakpoint: window.matchMedia('(max-width: 749.9px)'),
  init: function () {
    this.addEvent();
    this.getParsedAPIUrls();
    this.pageReloadOnBrowserBackButton();
  },
  pageReloadOnBrowserBackButton: function () {
    window.addEventListener('pageshow', function (event) {
      var historyTraversal =
        event.persisted ||
        (typeof performance != 'undefined' && (performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming).type == 'back_forward');
      if (historyTraversal) {
        window.location.reload();
      }
    });
  },
  getParsedAPIUrls: function () {
    const apiUrls = this.productDetailParentDiv?.dataset.attrGeneric || '';
    const parsedAPIUrls = apiUrls && JSON.parse(apiUrls?.replace(/&quot;/g, '"'));
    if (parsedAPIUrls) {
      this.addToWatchListUrl = parsedAPIUrls?.AddToWatchListUrl;
      this.addItemsToCartUrl = parsedAPIUrls?.AddItemsToCartUrl;
      this.getVariantsUrl = parsedAPIUrls?.GetVariantsUrl;
      this.getShareProductLinkUrl = parsedAPIUrls?.GetShareProductLinkUrl;
      this.categoriesApiUrl = parsedAPIUrls?.CategoriesApiUrl;
      this.cartPageUrl = parsedAPIUrls?.CartPageUrl;
      this.checkoutUrl = parsedAPIUrls?.CheckoutUrl;
      this.loggedIn = parsedAPIUrls?.LoggedIn;
      this.popUpIdAddToWatchListHelpModal = parsedAPIUrls?.PopUpIdAddToWatchListHelpModal;
      this.popUpIdAddToWatchListGuestModal = parsedAPIUrls?.PopUpIdAddToWatchListGuestModal;
      this.popUpIdAvailableFormatModal = parsedAPIUrls?.PopUpIdAvailableFormatModal;
      this.popUpIdDRMLicenseModal = parsedAPIUrls?.PopUpIdDRMLicenseModal;
      this.popUpIdAboutPdfDrmFormatModal = parsedAPIUrls?.PopUpIdAboutPdfDrmFormatModal;
      this.popUpIdAddToCartAPIErrorModal = parsedAPIUrls?.PopUpIdAddToCartAPIErrorModal;
      this.popUpIdItemExistsInCartModal = parsedAPIUrls?.PopUpIdItemExistsInCartModal;
      this.popUpIdItemExistsInDifferentCurrencyInCartModal = parsedAPIUrls?.PopUpIdItemExistsInDifferentCurrencyInCartModal;
      this.productSku = parsedAPIUrls?.sku;
      this.publisherId = parsedAPIUrls?.PublisherId;
    }
  },
  addEvent: function () {
    const openModalButtons = this.productDetailParentDiv?.querySelectorAll<HTMLButtonElement>('.saig-a-button.button-help-text, .open-license');
    const saveToWatchListButtons = this.productDetailParentDiv?.querySelectorAll<HTMLButtonElement>('.saig-a-link.add-to-watchlist-link');
    const emailButton = this.productDetailParentDiv?.querySelector<HTMLButtonElement>('.saig-a-button.email-button');
    const printButton = this.productDetailParentDiv?.querySelector<HTMLButtonElement>('.saig-a-button.print-button');
    const copyButton = this.productDetailParentDiv?.querySelector<HTMLButtonElement>('.saig-a-button.copy-button');
    const viewMore = this.productDetailParentDiv?.querySelector<HTMLElement>('.saig-a-link.view-more');
    const viewMoreDec = this.productDetailParentDiv?.querySelector<HTMLElement>('.saig-o-product-header__description__view-more');

    const addToCartButton = this.productDetailParentDiv?.querySelector<HTMLButtonElement>('.add-to-cart-button');
    const addToCartButtonMobile = this.productDetailParentDiv?.querySelector<HTMLButtonElement>('.add-to-cart-button-mobile');
    const goToCartButtonMobile = this.productDetailParentDiv?.querySelector<HTMLButtonElement>('.go-to-cart-button');
    const loginButton = this.productDetailParentDiv?.querySelector<HTMLButtonElement>('.login-button');
    const categoriesAccordion = this.productDetailParentDiv?.querySelector<HTMLButtonElement>('.category-accordion-button');
    const subCategoriesAccordion = this.productDetailParentDiv?.querySelector<HTMLButtonElement>('.subcategory-accordion-button');
    const viewSupersededLink = this.productDetailParentDiv?.querySelector<HTMLButtonElement>(
      '.saig-o-product-header__view-superseded-by .view-superseded-by-button'
    );
    const requestQuoteButton = this.productDetailParentDiv?.querySelector<HTMLButtonElement>('.request-quote-button');

    [].forEach.call(openModalButtons, (button: HTMLButtonElement) => {
      button?.addEventListener('click', this.openHelpModal.bind(this));
    });

    [].forEach.call(saveToWatchListButtons, (saveToWatchListButton: HTMLButtonElement) => {
      saveToWatchListButton?.addEventListener('click', this.saveToWatchList.bind(this));
    });

    viewMore?.addEventListener('click', this.toggleViewMore.bind(this));
    viewMoreDec?.addEventListener('click', this.toggleViewMoreDesc.bind(this));
    emailButton?.addEventListener('click', this.emailProduct.bind(this));
    printButton?.addEventListener('click', this.printProduct.bind(this));
    copyButton?.addEventListener('click', this.copyProduct.bind(this));
    addToCartButton?.addEventListener('click', this.addToCartClickHandler.bind(this));
    addToCartButtonMobile?.addEventListener('click', this.addToCartMobileClickHandler.bind(this));
    goToCartButtonMobile?.addEventListener('click', this.goToCartMobileClickHandler.bind(this));
    loginButton?.addEventListener('click', this.loginClickHandler.bind(this));
    categoriesAccordion?.addEventListener('click', this.categoriesClickHandler.bind(this));
    subCategoriesAccordion?.addEventListener('click', this.categoriesClickHandler.bind(this));
    document?.addEventListener('click', this.documentClickHandler.bind(this));
    viewSupersededLink?.addEventListener('click', this.viewSupersededLinkClickHandler.bind(this));
    requestQuoteButton?.addEventListener('click', this.requestQuoteClickHandler.bind(this));
    window.addEventListener('openPriceSection', (event: any) => {
      this.goToCartClickHandler(event);
    });
    this.PriceSectionOverlay?.addEventListener('click', this.showHideOverlayHandler.bind(this));
    window.addEventListener('load', () => {
      this.onPageLoadHandler();
    });

    window.addEventListener('dropdownChange', (event: any) => {
      event?.detail.inputName == 'currency'
        ? this.currencyChanged()
        : event?.detail.inputName == 'product-formats'
        ? this.productFormatChanged()
        : '';
    });

    window.addEventListener('radioCheckboxChange', (event) => {
      const inputId = event.detail.inputId;
      const errorMessageDiv = document?.querySelector<HTMLElement>('.saig-a-radiocheckbox__status.' + inputId);
      const inputElement = document?.querySelector<HTMLInputElement>('#' + inputId);
      inputElement?.checked ? errorMessageDiv?.classList.add('display-none') : '';
    });
  },
  viewSupersededLinkClickHandler: function (event: any) {
    event.preventDefault();
    event.stopPropagation();
    const productInfoAccordion = this.productDetailParentDiv?.querySelector<HTMLButtonElement>('.general-product-info-button');
    const viewMore = this.productDetailParentDiv?.querySelector<HTMLElement>('.saig-a-link.view-more');
    viewMore && (viewMore.innerText == 'View less information' ? '' : this.toggleViewMore());
    productInfoAccordion?.parentElement?.classList.contains('expanded') ? '' : productInfoAccordion?.parentElement?.classList.add('expanded');
    const accordionOffset = productInfoAccordion?.getBoundingClientRect();
    const headerEl = document.querySelector<HTMLElement>('.saig-o-header-menu');
    const headerSecondary = document.querySelector<HTMLElement>('.saig-o-secondary-header');
    const headerSecondaryOffset = headerSecondary?.getBoundingClientRect();
    const headerOffset = headerEl?.getBoundingClientRect();
    const heightHeader = headerOffset?.height ?? 0;
    const accordionOffsetTop = accordionOffset?.top ?? 0;
    const headerSecondaryOffsetTop = headerSecondaryOffset?.top ?? 0;
    const scrollTopValue = accordionOffsetTop - headerSecondaryOffsetTop - heightHeader;
    window.scrollTo({ top: scrollTopValue, behavior: 'smooth' });
  },
  addEventProductFormatDropdown: function () {
    const dropdown__options = this.productDetailParentDiv?.querySelectorAll<HTMLDivElement>(
      '.saig-m-dropdown.product-format-dropdown .saig-m-dropdown__option'
    );

    [].forEach.call(dropdown__options, (node: HTMLElement) => {
      node?.addEventListener('mouseenter', this.hoverDropDownOptionHandler.bind(this));
      node?.addEventListener('click', this.clickDropDownOptionHandler.bind(this));
    });
  },
  hoverDropDownOptionHandler: function (event: any) {
    event.preventDefault();
    const nodes = event.currentTarget.parentElement.children;
    [].forEach.call(nodes, (node: HTMLElement) => {
      node.classList.remove('highlight');
      node.classList.remove('chosen');
    });
    event.currentTarget.classList.add('highlight');
  },
  clickDropDownOptionHandler: function (event: any) {
    event.preventDefault();
    const selectedValue = event.currentTarget.dataset.value;
    const parentNode = event.currentTarget.closest('.saig-m-dropdown__dropdown');
    const inputName = parentNode.dataset.name;
    const selectedTextElm = parentNode?.querySelector('.saig-m-dropdown__header-text-content');
    selectedTextElm.innerText = event.currentTarget.innerText;
    const inputHidden = document?.querySelector<HTMLInputElement>("input[name='" + inputName + "']");
    inputHidden!.value = selectedValue;
    inputHidden!.dataset.attr = event.currentTarget.dataset.attr;

    window.dispatchEvent(new CustomEvent('dropdownChange', { detail: { inputName: inputHidden?.name } }));
  },
  getCategories: function (event: any) {
    getCategoriesAndSubCategories(this.categoriesApiUrl ?? '', this.sku, this.publisherId)
      .then((response) => {
        if (response) {
          this.populateCategories(response);
          this.populateSubCategories(response);
          this.categoriesFlag = true;
        }
      })
      .catch((error) => {
        console.log('Error in API call: ' + error);
      });
  },
  populateCategories: function (response: any) {
    const accordionContentCategory = this.productDetailParentDiv?.querySelector('.saig-m-accordion-item__content.Category');
    const categories =
      `<div class="saig-m-accordion-item__link-list">` +
      response.category
        .map((item?: any) => {
          return (
            `<div class="saig-m-accordion-item__link"><a href=` +
            item.categoryLink +
            ` class="saig-a-link saig-a-link--icon-before">
              <svg class=" saig-a-icon" aria-hidden="true" viewBox="0 0 14 11" width="14" height="11">
                <use xlink:href="/assets/images/icons.svg#saig-arrow-right-bold"></use>
              </svg>` +
            item.name +
            `</a></div>`
          );
        })
        .join(' ') +
      '</div>';

    accordionContentCategory && (accordionContentCategory.innerHTML = categories);
  },
  populateSubCategories: function (response: any) {
    const accordionContentSubCategory = this.productDetailParentDiv?.querySelector('.saig-m-accordion-item__content.SubCategory');
    const subCategories =
      `<div class="saig-m-accordion-item__link-list">` +
      response.subCategory
        .map((item?: any) => {
          return (
            `<div class="saig-m-accordion-item__link"><a href=` +
            item.categoryLink +
            ` class="saig-a-link saig-a-link--icon-before">
              <svg class=" saig-a-icon" aria-hidden="true" viewBox="0 0 14 11" width="14" height="11">
                <use xlink:href="/assets/images/icons.svg#saig-arrow-right-bold"></use>
              </svg>` +
            item.name +
            `</a></div>`
          );
        })
        .join(' ') +
      '</div>';
    accordionContentSubCategory && (accordionContentSubCategory.innerHTML = subCategories);
  },
  categoriesClickHandler: function (event: any) {
    event?.preventDefault();
    event?.stopPropagation();
    const h2Title = event?.currentTarget.closest('.saig-m-accordion-item__header-wrapper');
    if (h2Title.classList.contains('expanded') && !this.categoriesFlag) {
      this.getCategories(event);
    }
  },
  loginClickHandler: function (event: any) {
    event?.preventDefault();
    event?.stopPropagation();
    window.redirectAfterLogin = false;
    window.selectedSku = this.sku;
    window.dispatchEvent(new CustomEvent('openLogin'));
    if (this.breakpoint.matches) {
      this.PriceSection?.classList.contains('show') ? this.PriceSection?.classList.remove('show') : this.PriceSection?.classList.add('show');
      this.PriceSectionOverlay?.classList.contains('hidden')
        ? this.PriceSectionOverlay?.classList.remove('hidden')
        : this.PriceSectionOverlay?.classList.add('hidden');
      this.PriceSectionMobile?.classList.contains('hide')
        ? this.PriceSectionMobile?.classList.remove('hide')
        : this.PriceSectionMobile?.classList.add('hide');
    }
  },
  documentClickHandler: function (event: any) {
    const addToWatchListResponse = document?.querySelectorAll<HTMLButtonElement>('.add-to-watchlist-response');
    [].forEach.call(addToWatchListResponse, (node: HTMLElement) => {
      node.classList.contains('display-none') ? '' : node.classList.add('display-none');
    });
  },
  onPageLoadHandler: function () {
    this.setDataAttrValues();
  },
  checkItemCanBeAdded: function () {
    let itemCanBeAdded = true;

    this.itemExistsInCartDifferentCurrency = false;
    const cartObject = document.querySelector('script[data-rct="cart-object"]');
    const jsonCartObj = cartObject?.textContent && JSON.parse(cartObject.textContent);
    jsonCartObj?.cartSummaryList.map((item: any) => {
      if (item.currencyMnemonic != this.currencyNode?.value) {
        itemCanBeAdded = false;
        this.itemExistsInCartDifferentCurrency = true;
        return;
      } else {
        if (this.sku == item.productSKU && !item.allowMultiple && !item.isMultiUserPDF) {
          itemCanBeAdded = false;
          return;
        }
      }
    });

    return itemCanBeAdded;
  },
  addToCartMobileClickHandler: function (event?: any) {
    event.preventDefault();
    event.stopPropagation();
    window.dispatchEvent(new CustomEvent('openPriceSection'));
    this.PriceSectionOverlay?.classList.contains('hidden')
      ? this.PriceSectionOverlay?.classList.remove('hidden')
      : this.PriceSectionOverlay?.classList.add('hidden');
    document?.querySelector('body')?.classList.add('modal-overlay-on');
    if (event.type == 'click') {
      this.PriceSectionMobile?.classList.contains('hide')
        ? this.PriceSectionMobile?.classList.remove('hide')
        : this.PriceSectionMobile?.classList.add('hide');
    } else {
      this.PriceSectionMobile?.classList.contains('hide') ? '' : this.PriceSectionMobile?.classList.add('hide');
    }
  },
  goToCartMobileClickHandler: function (event?: any) {
    event.preventDefault();
    event.stopPropagation();
    if (this.IsDigitalPdt == 'true' && !this.validateTermsCheckbox()) {
      return;
    }
    if (this.checkItemCanBeAdded()) {
      this.addItemsToCart(event, 'mobile');
      this.PriceSection?.classList.contains('show') ? this.PriceSection?.classList.remove('show') : this.PriceSection?.classList.add('show');
      this.PriceSectionOverlay?.classList.contains('hidden')
        ? this.PriceSectionOverlay?.classList.remove('hidden')
        : this.PriceSectionOverlay?.classList.add('hidden');
    } else {
      this.itemExistsInCartDifferentCurrency
        ? this.showModal(true, this.popUpIdItemExistsInDifferentCurrencyInCartModal)
        : this.showModal(true, this.popUpIdItemExistsInCartModal);
      this.PriceSectionMobile?.classList.contains('hide')
        ? this.PriceSectionMobile?.classList.remove('hide')
        : this.PriceSectionMobile?.classList.add('hide');
      this.PriceSection?.classList.contains('show') ? this.PriceSection?.classList.remove('show') : this.PriceSection?.classList.add('show');
      this.PriceSectionOverlay?.classList.contains('hidden')
        ? this.PriceSectionOverlay?.classList.remove('hidden')
        : this.PriceSectionOverlay?.classList.add('hidden');
    }
  },
  showHideOverlayHandler: function (event?: any) {
    event?.preventDefault();
    event?.stopPropagation();
    document?.querySelector('body')?.classList.remove('modal-overlay-on');
    this.PriceSectionOverlay?.classList.contains('hidden')
      ? this.PriceSectionOverlay?.classList.remove('hidden')
      : this.PriceSectionOverlay?.classList.add('hidden');
    this.PriceSection?.classList.contains('show') ? this.PriceSection?.classList.remove('show') : this.PriceSection?.classList.add('show');
    this.PriceSectionMobile?.classList.contains('hide')
      ? this.PriceSectionMobile?.classList.remove('hide')
      : this.PriceSectionMobile?.classList.add('hide');
  },
  goToCartClickHandler: function (event?: any) {
    event?.preventDefault();
    event?.stopPropagation();

    if (event.type == 'click') {
      this.PriceSection?.classList.contains('show') ? this.PriceSection?.classList.remove('show') : this.PriceSection?.classList.add('show');
    } else {
      this.PriceSection?.classList.contains('show') ? '' : this.PriceSection?.classList.add('show');
    }

    document?.querySelector('body')?.classList.remove('modal-overlay-on');
  },
  addToCartClickHandler: function (event?: any) {
    event.preventDefault();
    event.stopPropagation();
    const isPopupShown = this.hasDRMSecureIcon == 'true' || this.IsDigitalPdt == 'false';
    const inputHidden = document?.querySelector<HTMLInputElement>("input[name='product-formats']");
    const dataAttr = inputHidden!.dataset.attr;
    const parsedDataAttr = dataAttr && JSON.parse(dataAttr?.replace(/&quot;/g, '"'));

    const popUpIdConfirmProductModal = parsedDataAttr?.ConfirmProductPopUpId;

    if (this.IsDigitalPdt == 'true' && !this.validateTermsCheckbox()) {
      return;
    }

    if (this.checkItemCanBeAdded()) {
      if (isPopupShown) {
        //check if DRM
        if (this.hasDRMSecureIcon == 'true') {
          this.showModal(
            true,
            this.popUpIdAboutPdfDrmFormatModal,
            () => {
              this.addItemsToCart(event);
            },
            {}
          );
        }
        //check if Hardcopy
        if (this.IsDigitalPdt == 'false') {
          this.showModal(
            true,
            popUpIdConfirmProductModal,
            () => {
              this.addItemsToCart(event);
            },
            {}
          );
        }
      } else {
        this.addItemsToCart(event);
      }
    } else {
      this.itemExistsInCartDifferentCurrency
        ? this.showModal(true, this.popUpIdItemExistsInDifferentCurrencyInCartModal)
        : this.showModal(true, this.popUpIdItemExistsInCartModal);
    }
  },
  addItemsToCart: function (event?: any, type?: string) {
    const qtyNode = this.productDetailParentDiv?.querySelector<HTMLInputElement>('input[name=quantity-dropdown]');
    const productObj = {
      currencyMnemonic: this.currencyNode?.value,
      licenceTerms: '',
      productFamily: 'STANDARD',
      productType: 'STANDARD',
      quantity: qtyNode?.value,
      sku: this.sku,
    };
    postAddProductToCart(this.addItemsToCartUrl ?? '', productObj)
      .then((response) => {
        if (response && response.flagSuccess === 1) {
          this.postAddtoCartEventToGA(qtyNode?.value);
          const cartObjectNode = document.querySelector('script[data-rct="cart-object"]');
          cartObjectNode && (cartObjectNode.textContent = JSON.stringify(response.data));

          if (type == 'mobile') {
            window.location.href = this.cartPageUrl;
          } else {
            window.dispatchEvent(new CustomEvent('getCartInfo'));
          }
        } else {
          this.showModal(true, this.popUpIdAddToCartAPIErrorModal);
        }
      })
      .catch((error) => {
        this.showModal(true, this.popUpIdAddToCartAPIErrorModal);
        console.log('Error in API call: ' + error);
      });
  },
  postAddtoCartEventToGA: function (quantity?: string) {
    try {
      var currentRegion = getCurrentRegion();
      quantity = quantity != null ? quantity : '1';

      const dataAttr = this.selectedProductFormat?.dataset.attr;
      const parsedDataAttr = dataAttr && JSON.parse(dataAttr?.replace(/&quot;/g, '"'));
      var price = parsedDataAttr?.Price.replace(/[^.0-9]/g, '');

      const productObj = {
        event: 'add_to_cart',
        region: currentRegion,
        currency: this.currencyNode?.value,
        value: parseFloat((parseFloat(price) * parseInt(quantity)).toFixed(2)),
        items: [
          {
            item_id: parsedDataAttr?.mastersku,
            item_name: parsedDataAttr?.ProductName,
            item_brand: parsedDataAttr?.PublisherName,
            item_variant: parsedDataAttr?.FriendlyFormat,
            price: parseFloat(price),
            quantity: parseInt(quantity),
          },
        ],
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(productObj);
    } catch {
      console.error('Error in add to cart event');
    }
  },
  validateTermsCheckbox: function (event?: any) {
    const checkbox =
      this.hasDRMSecureIcon == 'true'
        ? this.productDetailParentDiv?.querySelector<HTMLInputElement>('.checkbox-drm')
        : this.productDetailParentDiv?.querySelector<HTMLInputElement>('.checkbox-normal');
    checkbox?.checked
      ? this.productDetailParentDiv?.querySelector('.saig-a-radiocheckbox__status.' + checkbox.id)?.classList.add('display-none')
      : this.productDetailParentDiv?.querySelector('.saig-a-radiocheckbox__status.' + checkbox?.id)?.classList.remove('display-none');
    if (checkbox?.checked) {
      return true;
    }
    return false;
  },
  hideTermsAcceptance: function () {
    const checkboxNormalDiv = this.productDetailParentDiv?.querySelector<HTMLDivElement>('.saig-a-radiocheckbox-normal');
    const checkboxDRMDiv = this.productDetailParentDiv?.querySelector<HTMLDivElement>('.saig-a-radiocheckbox-drm');

    if (this.IsDigitalPdt == 'false') {
      this.termsCheckboxDiv?.classList.add('display-none');
    } else {
      this.termsCheckboxDiv?.classList.remove('display-none');
    }

    if (this.hasDRMSecureIcon == 'true') {
      checkboxDRMDiv?.classList.remove('display-none');
      checkboxNormalDiv?.classList.add('display-none');
    } else {
      checkboxDRMDiv?.classList.add('display-none');
      checkboxNormalDiv?.classList.remove('display-none');
    }
  },
  currencyChanged: function () {
    const productFormatOptions = this.productDetailParentDiv?.querySelector<HTMLElement>(
      '.saig-m-dropdown.product-format-dropdown .saig-m-dropdown__options-inner'
    );
    getGetVariants(this.getVariantsUrl ?? '', this.currencyNode?.value)
      .then((response) => {
        if (response) {
          productFormatOptions?.innerHTML && (productFormatOptions.innerHTML = response.toString());
          const productSku = this.selectedProductFormat?.value;
          const selectedProduct = this.productDetailParentDiv?.querySelector<HTMLElement>('[data-value="' + productSku + '"]');
          this.selectedProductFormat?.dataset.attr && (this.selectedProductFormat.dataset.attr = selectedProduct?.dataset.attr);
          this.productFormatChanged();
          this.addEventProductFormatDropdown();
        }
      })
      .catch((error) => {
        console.log('Error in API call: ' + error);
      });
  },
  setDataAttrValues: function () {
    const dataAttr = this.selectedProductFormat?.dataset.attr;
    const parsedDataAttr = dataAttr && JSON.parse(dataAttr?.replace(/&quot;/g, '"'));
    if (parsedDataAttr) {
      this.IsDigitalPdt = parsedDataAttr?.IsDigitalPdt;
      this.isPdf = parsedDataAttr?.IsPdf;
      this.hasDRMSecureIcon = parsedDataAttr?.HasDRMSecureIcon;
      this.itemDisplayPrice = parsedDataAttr?.DisplayPrice;
      this.showRequestQuote = parsedDataAttr?.ShowRequestQuote;
      this.requestQuoteUrl = parsedDataAttr?.RequestQuoteUrl;
      this.itemGstExempt = parsedDataAttr?.GstExempt;
      this.isLoginRequired = parsedDataAttr?.IsLoginRequired;
    }
    this.selectedProductFormat?.value && (this.sku = this.selectedProductFormat?.value);
  },
  productFormatChanged: function () {
    this.setDataAttrValues();
    this.hideTermsAcceptance();
    this.setIcon();
    this.setProductFormatChanges();
    this.correctUrl();
  },
  correctUrl: function () {
    const url = window.location.href;
    var urlSplit = url.split('?');
    var obj = { Title: 'Product detail', Url: urlSplit[0] };
    history.pushState(obj, obj.Title, obj.Url);
  },
  resetQuantity: function () {
    const quantityTextNode = this.productDetailParentDiv?.querySelector<HTMLElement>(
      '.saig-o-product-detail-main__cart-info-product-qty .saig-m-dropdown__header-text-content'
    );
    const quantityDropdownOptions = this.productDetailParentDiv?.querySelectorAll<HTMLElement>(
      '.saig-o-product-detail-main__cart-info-product-qty .saig-m-dropdown__option'
    );
    const qtyHiddenNode = this.productDetailParentDiv?.querySelector<HTMLInputElement>('input[name=quantity-dropdown]');
    quantityTextNode && (quantityTextNode.innerText = '01');
    qtyHiddenNode && (qtyHiddenNode.value = '01');
    [].forEach.call(quantityDropdownOptions, (node: HTMLElement, index: number) => {
      node.classList.remove('highlight');
      node.classList.remove('chosen');
      index == 0 ? node.classList.add('chosen') : '';
    });
  },
  setProductFormatChanges: function () {
    const priceNode = this.productDetailParentDiv?.querySelector<HTMLElement>('.saig-o-product-detail-main__cart-info-price-value');
    const cartInfoActions = this.productDetailParentDiv?.querySelector<HTMLElement>('.saig-o-product-detail-main__cart-info-actions');
    const currencyContainer = this.productDetailParentDiv?.querySelector<HTMLElement>('.saig-o-product-detail-main__cart-info-currency-container');
    const requestQuote = this.productDetailParentDiv?.querySelector<HTMLElement>('.saig-o-product-detail-main__cart-info-request-quote-container');
    const gstNode = this.productDetailParentDiv?.querySelector<HTMLElement>('.saig-o-product-detail-main__cart-info-price-gst');
    const loginContainer = this.productDetailParentDiv?.querySelector<HTMLElement>('.saig-o-product-detail-main__cart-info-login-container');
    const addToCartContainer = this.productDetailParentDiv?.querySelector<HTMLElement>(
      '.saig-o-product-detail-main__cart-info-add-to-cart-container'
    );
    const quantityDropdownNode = this.productDetailParentDiv?.querySelector<HTMLButtonElement>(
      '.saig-o-product-detail-main__cart-info-product-qty .saig-m-dropdown__header'
    );
    if (this.showRequestQuote == 'false') {
      priceNode && (priceNode.innerText = this.itemDisplayPrice);
      cartInfoActions?.classList.remove('display-none');
      currencyContainer?.classList.remove('display-none');
      requestQuote?.classList.add('display-none');
    } else {
      cartInfoActions?.classList.add('display-none');
      currencyContainer?.classList.add('display-none');
      requestQuote?.classList.remove('display-none');
    }
    this.resetQuantity();
    quantityDropdownNode && (quantityDropdownNode.disabled = this.hasDRMSecureIcon == 'true');
    gstNode && (gstNode.innerText = this.itemGstExempt);
    if (!this.loggedIn && this.isLoginRequired == 'true') {
      loginContainer?.classList.remove('display-none');
      addToCartContainer?.classList.add('display-none');
    } else {
      loginContainer?.classList.add('display-none');
      addToCartContainer?.classList.remove('display-none');
    }
  },
  setIcon: function () {
    if (this.IsDigitalPdt == 'true') {
      this.productDetailParentDiv?.querySelector('.saig-a-icon.pdf-icon')?.classList.remove('display-none');
      this.productDetailParentDiv?.querySelector('.saig-a-icon.hardcopy')?.classList.add('display-none');
    } else {
      this.productDetailParentDiv?.querySelector('.saig-a-icon.pdf-icon')?.classList.add('display-none');
      this.productDetailParentDiv?.querySelector('.saig-a-icon.hardcopy')?.classList.remove('display-none');
    }
  },
  emailProduct: function (event?: any) {
    event.preventDefault();
    const productDescription = this.productDetailParentDiv?.querySelector<HTMLElement>('.saig-o-product-header__description');

    window.location.href = 'mailto:?subject=' + productDescription?.innerText + '&body=' + encodeURI(window.location.href);
  },
  printProduct: function (event?: any) {
    event.preventDefault();
    var divContents = document?.querySelector<HTMLDivElement>('.saig-o-product-detail-main__main');

    const bodyElement = document.getElementsByTagName('body')[0];
    bodyElement?.setAttribute('style', 'visibility:hidden');
    divContents?.classList.add('printable-area');

    window.print();

    bodyElement?.setAttribute('style', 'visibility:visible');
    divContents?.classList.remove('printable-area');
  },
  copyProduct: function (event?: any) {
    event.preventDefault();
    const qtyNode = this.productDetailParentDiv?.querySelector<HTMLInputElement>('input[name=quantity-dropdown]');
    const productObj = {
      currencyMnemonic: this.currencyNode?.value,
      licenceTerms: '',
      productFamily: 'STANDARD',
      productType: 'STANDARD',
      quantity: qtyNode?.value,
      sku: this.sku,
    };
    getShareProductLink(this.getShareProductLinkUrl ?? '', productObj)
      .then(async (response) => {
        if (response) {
          await navigator.clipboard.writeText(response.toString());
          console.log('Copied!!!');
        }
      })
      .catch((error) => {
        console.log('Error: ' + error);
      });
  },
  requestQuoteClickHandler: function (event?: any) {
    event.preventDefault();
    window.location.href = this.requestQuoteUrl;
  },
  toggleViewMore: function () {
    const viewMore = this.productDetailParentDiv?.querySelector<HTMLElement>('.saig-a-link.view-more');
    viewMore && (viewMore.innerText = viewMore.innerText == 'View less information' ? 'View more information' : 'View less information');
    const showHideItems = this.productDetailParentDiv?.querySelectorAll<HTMLDivElement>('.epi-saig-item-wrapper.product-detail-accordion-item');
    [].forEach.call(showHideItems, (itemDiv: HTMLElement) => {
      itemDiv?.classList.contains('hide-mobile') ? itemDiv?.classList.remove('hide-mobile') : itemDiv?.classList.add('hide-mobile');
    });
  },
  toggleViewMoreDesc: function (event?: any) {
    event.preventDefault();
    event.stopPropagation();
    const viewMore = this.productDetailParentDiv?.querySelector<HTMLElement>('.saig-o-product-header__description__view-more');
    viewMore &&
      (viewMore.innerText.startsWith('Show less')
        ? (viewMore.innerHTML = viewMore.innerHTML.replace('less', 'more'))
        : (viewMore.innerHTML = viewMore.innerHTML.replace('more', 'less')));
    viewMore && viewMore.classList.toggle('expanded');
    const showHideItems = this.productDetailParentDiv?.querySelector<HTMLElement>('.saig-o-product-header__description_details');
    showHideItems && showHideItems.classList.toggle('expanded');
  },
  openHelpModal: function (event?: any) {
    event.preventDefault();
    event.stopPropagation();
    const self = this;
    switch (true) {
      case event.currentTarget.classList.contains('available-formats-help'):
        this.showModal(true, self.popUpIdAvailableFormatModal);
        break;
      case event.currentTarget.classList.contains('product-formats-help'):
        const inputHidden = document?.querySelector<HTMLInputElement>("input[name='product-formats']");
        const dataAttr = inputHidden!.dataset.attr;
        const parsedDataAttr = dataAttr && JSON.parse(dataAttr?.replace(/&quot;/g, '"'));
        if (parsedDataAttr) {
          this.popUpIdProductFormatModal = parsedDataAttr?.ProductFormatPopUpId;
        }
        this.showModal(true, self.popUpIdProductFormatModal);
        break;
      case event.currentTarget.classList.contains('add-to-watchlist-help'):
        this.showModal(true, self.popUpIdAddToWatchListHelpModal);
        break;
      case event.currentTarget.classList.contains('open-license'):
        this.showModal(true, self.popUpIdDRMLicenseModal);
        break;
    }
  },
  showModal: function (show: boolean, popUpId?: string, confirmCallback?: any, closeCallback?: any) {
    window.dispatchEvent<'selectModal'>(
      new CustomEvent('selectModal', { detail: { popUpId: popUpId, confirmCallback, closeCallback, selfControl: true } })
    );
  },
  saveToWatchList: function (event?: any) {
    if (!this.loggedIn) {
      this.showModal(true, this.popUpIdAddToWatchListGuestModal);
    } else {
      postAddProductToWatchList(this.addToWatchListUrl ?? '', this.productSku)
        .then((response) => {
          let nodesCollection;
          switch (response) {
            case 'success':
              nodesCollection = this.addToWishListSuccessDiv;
              break;
            case 'recordExist':
              nodesCollection = this.addToWishListRecordExistDiv;
              break;
            case 'error':
              nodesCollection = this.addToWishListErrorDiv;
              break;
            case 'maxlimit':
              nodesCollection = this.addToWishListMaxErrorDiv;
              break;
            case 'loginerror':
              nodesCollection = this.addToWishListGuestDiv;
              break;
            default:
              nodesCollection = this.addToWishListGuestDiv;
              break;
          }
          [].forEach.call(nodesCollection, (node: HTMLElement) => {
            node?.classList.remove('display-none');
          });
        })
        .catch((error) => {
          [].forEach.call(this.addToWishListErrorDiv, (node: HTMLElement) => {
            node?.classList.remove('display-none');
          });
          console.log('Error in API call: ' + error);
        });
    }
  },
};

productDetailPage.init();

export { productDetailPage };
